import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CreatePotluck from "./CreatePotluck";
import PotluckList from "./PotluckList";
import PotluckStandalone from "./PotluckStandalone";
import { Container } from "@material-ui/core";
import { AppBar, Toolbar, Typography, Button, ButtonGroup } from "@material-ui/core";
import Home from "./Home";
import logo from '../images/whatluck-logo.png'
import NavbarComponent from "./NavbarComponent";
import Details from "./TechnicalDetails"
import AdminLogin from "./Admin/AdminLogin";

function MainMenu() {
  return (
    <BrowserRouter>
      <NavbarComponent />
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/createpotluck" element={<CreatePotluck />} />
          <Route path="/PotluckList" element={<PotluckList />} />
          <Route path="/potlucks/:idCode" element={<PotluckStandalone />} />
          <Route path="/potlucks/:idCode/potluckcreated" element={<PotluckStandalone />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/details" element={<Details />} />
        </Routes>
      </Container>
    </BrowserRouter>
  );
}

export default MainMenu;
